import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: '100%',
    margin: 0,
  },
  paper: {
    boxShadow: '0px 3px 6px #0000001A',
    textAlign: 'center',
    padding: '0',
  },
  tabContent: {},
}));

export default useStyles;
